"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _drei = require("@react-three/drei");
var _lottieReact = _interopRequireDefault(require("lottie-react"));
var _paulCorePackage = require("paul-core-package");
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _loadingLight = _interopRequireDefault(require("../shared/assets/icons/animations/loadingLight.json"));
var _loadingDark = _interopRequireDefault(require("../shared/assets/icons/animations/loadingDark.json"));
var _LoaderModule = _interopRequireDefault(require("../styles/components/Loader.module.css"));
var _selectors = require("../redux/selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Loader = () => {
  const {
    active
  } = (0, _drei.useProgress)();
  const theme = (0, _reactRedux.useSelector)(_selectors.getPackageTheme);
  const hasData = (0, _reactRedux.useSelector)(_selectors.selectHasData);
  const loading = !hasData || active;
  return /*#__PURE__*/_react.default.createElement(_drei.Html, {
    fullscreen: true,
    wrapperClass: "".concat(_LoaderModule.default.html, " ").concat(_LoaderModule.default[theme], " ").concat(loading ? _LoaderModule.default.on : _LoaderModule.default.off)
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_lottieReact.default, {
    animationData: theme === _paulCorePackage.constants.themeKey.light ? _loadingLight.default : _loadingDark.default,
    style: {
      height: '25%',
      maxHeight: 190
    }
  })));
};
var _default = exports.default = Loader;